import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@xing-com/button';
import { useEntityPageStore } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';

import { trackEditSaving } from '../../tracking';

import * as Styled from './edit-actions.styes';

type EditActionsProps = {
  disabled?: boolean;
  discardAction: () => void;
  saveAction: () => void;
  isSaving?: boolean;
  noMarginTop?: boolean;
  default?: string;
  trackingData: {
    module: string;
    part: string;
  };
};
export const EditActions: FC<EditActionsProps> = ({
  disabled,
  discardAction,
  saveAction,
  isSaving,
  noMarginTop = false,
  trackingData,
}) => {
  const focusType = useEntityPageStore(
    ({ pageContext }) => pageContext.focusType
  );
  const pageId = useEntityPageStore(({ pageContext }) => pageContext.pageId);

  return (
    <Styled.ActionsContainer $noMarginTop={noMarginTop}>
      <Styled.DiscardButton
        size="medium"
        // @ts-expect-error TS(2769) FIXME: No overload matches this call.
        tabindex=""
        data-cy="DISCARD_CONTACT_BUTTON"
        disabled={isSaving || disabled}
        onClick={discardAction}
      >
        <FormattedMessage
          id="EP_EDIT_ACTION_DISCARD"
          defaultMessage="EP_EDIT_ACTION_DISCARD"
        />
      </Styled.DiscardButton>
      <Button
        variant="primary"
        size="medium"
        // @ts-expect-error TS(2322) FIXME: Type '{ children: Element; variant: "primary"; siz... Remove this comment to see the full error message
        tabindex=""
        disabled={disabled}
        onClick={() => {
          trackEditSaving({
            focusType: focusType,
            itemId: pageId,
            module: trackingData.module,
            part: trackingData.part,
          });
          saveAction();
        }}
        data-cy="PUBLISH_CONTACT_BUTTON"
        loading={isSaving}
      >
        <FormattedMessage
          id="EP_EDIT_ACTION_PUBLISH"
          defaultMessage="EP_EDIT_ACTION_PUBLISH"
        />
      </Button>
    </Styled.ActionsContainer>
  );
};
